<template>
  <!-- Just render the routed page -->
  <router-view></router-view>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
/* You can keep global styles here if you want them across all pages */
body {
  font-family: 'Inter', Arial, sans-serif;
  margin: 0;
  padding: 0;
  background-color: #171723;
  background-image: url('https://firebasestorage.googleapis.com/v0/b/networkchuck-academy-prod.firebasestorage.app/o/SKY%20BG2.png?alt=media&token=eca3d63d-8294-4dcf-89ec-20bf618c44ae');
  background-repeat: no-repeat;
  background-size: cover;
}

a.button {
  display: inline-block;
  font-weight: bold;
  font-size: 16px;
  color: #000 !important;
  background-color: #CA9F43;
  border-radius: 48px;
  padding: 12px 35px;
  text-decoration: none !important;
  margin-top: 20px;
  width: fit-content;
}

a.link {
  color: #CA9F43 !important;
  font-weight: bold;
  text-decoration: none !important;
}
</style>

